import { render, staticRenderFns } from "./ProductAdmin.vue?vue&type=template&id=383c652e&scoped=true"
import script from "./ProductAdmin.vue?vue&type=script&lang=js"
export * from "./ProductAdmin.vue?vue&type=script&lang=js"
import style0 from "./ProductAdmin.vue?vue&type=style&index=0&id=383c652e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383c652e",
  null
  
)

export default component.exports